import { Injectable } from '@angular/core';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';

dayjs.extend(utc as dayjs.PluginFunc);

@Injectable({ providedIn: 'root' })
export class DateService {

  private readonly formatDate = 'MM/DD/YYYY';

  constructor() { }

  public toFormatDate(date?: Date | string, format: string = this.formatDate) {
    return date ? dayjs(date).format(format) : dayjs().format(format);
  }

  public toFormatUtcDate(date?: Date | string, format: string = this.formatDate) {
    return date ? dayjs.utc(date).format(format) : dayjs.utc().format(format);
  }

  public toIsoDate(date) {
    let isoDate = date;
    if (!isoDate) {
      return undefined;
    }
    if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(isoDate)) {
      isoDate = dayjs(isoDate).format('YYYY-MM-DD');
    }
    return (new Date(isoDate)).toISOString();
  }

  public toIsoDateNow() {
    return dayjs().toISOString();
  }
}
